/* eslint-disable sort-keys */
import type * as core from '../../../../../../../core'

export const query: core.mosaic.Page.Query = {
  selection: {
    if: [
      [
        {
          '=': [
            {
              '@$': 'healthCheckEntityId',
            },
            'ent:!health-check:!assessment',
          ],
        },
        {
          '@': 'assessmentLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'healthCheckEntityId',
            },
            'ent:!health-check:!track',
          ],
        },
        {
          '@': 'trackLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'healthCheckEntityId',
            },
            'ent:!health-check:!dimension',
          ],
        },
        {
          '@': 'dimensionLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'healthCheckEntityId',
            },
            'ent:!health-check:!criteria',
          ],
        },
        {
          '@': 'criteriaLens',
        },
      ],
      {
        '@': 'InstitutionLens',
      },
    ],
  },
  subqueries: {
    trackLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!health-check:!track',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'overview',
                        },
                      },
                      name: 'Overview',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      healthCheckEntityId: {
                        '@_': 'id',
                      },
                      healthCheckRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'overview',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    criteriaLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!health-check:!criteria',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'overview',
                        },
                      },
                      name: 'Overview',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      healthCheckEntityId: {
                        '@_': 'id',
                      },
                      healthCheckRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'overview',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    dimensionLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!health-check:!dimension',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'overview',
                        },
                      },
                      name: 'Overview',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      healthCheckEntityId: {
                        '@_': 'id',
                      },
                      healthCheckRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'overview',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    assessmentLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'healthCheckRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!health-check:!assessment',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'healthCheckRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '[]': [
              {
                '{}': {
                  goto: {
                    '{}': {
                      variables: {
                        '{}': {},
                      },
                      navigationId: 'overview',
                    },
                  },
                  name: 'Overview',
                },
              },
            ],
          },
        },
      },
    },
    InstitutionLens: {
      target: 'ent:!health-check:!assessment',
      quantity: 1,
      selection: {
        '{}': {
          title: 'Overview',
        },
      },
    },
  },
}
